<div class="p-2 min-h-screen">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-2">
    <h3 class="font-bold">{{ '::Orders' | abpLocalization }}</h3>
  </div>

  <!-- filtro -->
  <div class="flex flex-col md:flex-row gap-2 mb-4 items-stretch">
    <div class="w-full md:w-1/3 px-1 flex items-stretch">
      <app-metro-form-select [size]="'md'" [placeholder]="'::Status' | abpLocalization" [options]="orderStatusOptions"
        [(ngModel)]="selectedStatus" (selectionChange)="onStatusChange($event)" [allowSearch]="false"
        selectedBackgroundClass="bg-metro-secondary" class="flex-1 h-full"></app-metro-form-select>
    </div>
    <div class="w-full md:w-2/3 px-1 flex items-stretch">
      <app-metro-date-input-picker
        class="w-full"
        [modeInput]="'range'"
        [size]="'md'"
        [startDateInput]="dateRange.start"
        [endDateInput]="dateRange.end"
        (rangeSelectedChange)="onDateRangeChange($event)">
      </app-metro-date-input-picker>
    </div>
  </div>


  <!-- listado de órdenes -->
  <div class="grid gap-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">

    @for (order of orders; track $index) {
    <app-metro-order-card-item [dateOrder]="order.creationTime" [status]="order.status" [itemCount]="order.itemCount"
      [totalPrice]="order.totalPrice" [orderNumber]="order.clientName" [isSommelierView]="true" [id]="order.id"
      [navigationPath]="'order'">
    </app-metro-order-card-item>
    }
  </div>
</div>